import { render, staticRenderFns } from "./DebugModal.vue?vue&type=template&id=ca16c00c"
import script from "./DebugModal.vue?vue&type=script&lang=js"
export * from "./DebugModal.vue?vue&type=script&lang=js"
import style0 from "./DebugModal.vue?vue&type=style&index=0&id=ca16c00c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports